import { useState } from "react";
import PropTypes from "prop-types";
import { useSaveContext } from "react-admin";
import { useFormContext } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Save } from "@mui/icons-material";

const ConfirmButton = ({
  title,
  description,
  cancelLabel,
  confirmLabel,
  buttonLabel,
  buttonIcon,
}) => {
  const [open, setOpen] = useState(false);
  const { save, saving } = useSaveContext();
  const { handleSubmit } = useFormContext();

  const handleConfirm = () => {
    setOpen(false);
    handleSubmit(save)();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={buttonIcon}
        disabled={saving}
        onClick={() => setOpen(true)}
      >
        {buttonLabel}
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {Array.isArray(description) ? (
            description.map((line, i) => (
              <DialogContentText key={i} sx={i > 0 ? { mt: 1.5 } : undefined}>
                {line}
              </DialogContentText>
            ))
          ) : (
            <DialogContentText>{description}</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>{cancelLabel}</Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            {confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ConfirmButton.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonIcon: PropTypes.node,
};

ConfirmButton.defaultProps = {
  cancelLabel: "Cancel",
  confirmLabel: "Confirm",
  buttonLabel: "Save",
  buttonIcon: <Save />,
};

export default ConfirmButton;
